import TenantGlobalPicker from './TenantGlobalPicker';
export default TenantGlobalPicker;
